<template>

  <v-dialog v-model="enabled_" :max-width="maxWidth">
    <slot name="activator" slot="activator"></slot>
    <v-card>
      <v-card-title class="headline">Show</v-card-title>
      <v-card-text>
        <v-container fluid="fluid" grid-list-xl="grid-list-xl">
          <v-flex v-for="(c, index) in columns" :key="index">
            <v-checkbox v-model="c.display" :label="c.text"></v-checkbox>
          </v-flex>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'ItemTableOptions',
  props: {
    enabled: {
      Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    },
    maxWidth: {
      type: String,
      default: '700px'
    }
  },
  computed: {
    columns () {
      if (!this.options || !this.options.columns) {
        return []
      }
      return this.options.columns.filter(c => c.displayable !== false)
    },

    enabled_: {
      get () {
        return this.enabled
      },
      set (v) {
        this.$emit('update:enabled', v)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ItemTableOptions.vue